<script setup>
import { inject } from 'vue';
import { ProjectsColumnheader } from '@/app/components';

const { listView } = inject('config');
const props = defineProps({
  index: {
    default: 0,
    required: false,
    type: Number,
  },
});
</script>

<template>
  <table aria-readonly="true" class="c-projects-table" role="grid">
    <thead class="c-projects-table__head">
      <tr role="row">
        <ProjectsColumnheader :index="props.index" category="name">
          {{ listView.projectHeading }}
        </ProjectsColumnheader>
        <ProjectsColumnheader :index="props.index" category="type">
          {{ listView.typeHeading }}
        </ProjectsColumnheader>
        <ProjectsColumnheader :index="props.index" category="status">
          {{ listView.statusHeading }}
        </ProjectsColumnheader>
        <th role="columnheader" scope="col">
          <span class="visually-hidden">{{ listView.eventsHeading }}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <slot />
    </tbody>
  </table>
</template>

<style lang="scss">
@import 'sass-mq';
@import '@/ui/styles/settings/breakpoints';
@import '@/ui/styles/settings/colors';

.c-projects-table {
  width: 100%;
  border-collapse: collapse;
}

.c-projects-table__head {
  display: none;

  @include mq($from: large) {
    display: table-header-group;
    background-color: map-get($color-grey, 6);
  }
}
</style>
